import DataListItemRoot, { Props } from './DataListItem'

export default function DataListItem(props: Props) {
  return <DataListItemRoot {...props} />
}
